"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Link from "next/link";
import Button from "@/app/components/UI/Button";
import { useRouter } from "@/app/hooks/useRouter";
import { Data } from "./data";
import { useTranslations } from "next-intl";
import { useAuth } from "@/app/context/AuthContext";
import { BagIcon, GuideBuyIcon, GuideSellIcon, MoneyLaunderingIcon, NotebookIcon, RulesIcon, SafetyIcon } from "@/app/components/UI/Icons";
const whiteGuideIconClassName = "w-12 h-12";
const whiteGuideActionIconClassName = "w-6 h-6";
const renderGuideIcon = (icon: string) => {
  switch (icon) {
    case "money-laundering":
      return <MoneyLaunderingIcon className={whiteGuideIconClassName} />;
    case "safety":
      return <SafetyIcon className={whiteGuideIconClassName} />;
    case "rules":
      return <RulesIcon className={whiteGuideIconClassName} />;
    case "notebook":
      return <NotebookIcon className={whiteGuideIconClassName} />;
    case "bag":
      return <BagIcon className={whiteGuideIconClassName} />;
    default:
      return null;
  }
};
export default function BeginnersGuide() {
  const $ = _c(192);
  const {
    token
  } = useAuth();
  const router = useRouter();
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("guide.WHERE_TO_START");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <h1 className="text-center md:text-start text-lg font-bold md:text-xl text-bluetiful-400">{t0}</h1>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("guide.GUIDE_HERO_TEXT");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <p className="pt-3 text-center mt-5 text-base text-charcoal-600 md:max-w-[450px] !leading-8 md:text-justify">{t2}</p>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("guide.START_NOW");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <div className="mt-8 flex justify-center md:block"><Link href="/comparison" className="text-bluetiful-400 bg-white border border-bluetiful-400 rounded-full w-fit py-3 px-10">{t4}</Link></div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div className="mb-10 md:mb-0">{t1}{t3}{t5}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex justify-end w-full"><img src="/images/guide/header.svg" alt="register" className="w-full h-full" /></div>;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6) {
    t8 = <div className="bg-bluetiful-400-gradient"><div className="container pt-40 md:pt-10 pb-10 px-8 md:px-20 mx-auto"><div className="md:pt-10"><div className="grid md:grid-cols-2 gap-x-16 items-center">{t6}{t7}</div></div></div></div>;
    $[17] = t6;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t("guide.GUIDE_TITLE_1");
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <h2 className="text-center text-lg md:text-xl font-bold text-charcoal-900">{t9}</h2>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t("guide.GUIDE_TEXT_1");
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11) {
    t12 = <p className="pt-3 mt-5 text-base text-charcoal-600 leading-8">{t11}</p>;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t12) {
    t13 = <div className="flex flex-col items-center w-full container px-8 md:px-20 mx-3 xl:px-0"><div className="my-10 md:my-24 ">{t10}{t12}</div></div>;
    $[27] = t10;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t) {
    t14 = t("guide.GUIDE_TITLE_2");
    $[30] = t;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14) {
    t15 = <h2 className="text-lg md:text-2xl font-bold text-charcoal-900">{t14}</h2>;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = Data.kycReasons.map((item, index) => <div key={index} className="flex flex-col items-center sm:h-full py-2 md:py-7 sm:py-0"><div className="">{renderGuideIcon(item.icon)}</div><h3 className="my-5 font-semibold text-charcoal-900">{t(item.title)}</h3><p className="text-charcoal-600 font-normal text-justify text-sm">{t(item.text)}</p></div>);
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <div className="flex justify-center w-full"><div className="sm:grid sm:grid-cols-3 gap-x-16 items-center pt-3 mt-5">{t16}</div></div>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t15 || $[39] !== t17) {
    t18 = <div className="text-center md:mt-10 md:mb-20">{t15}{t17}</div>;
    $[38] = t15;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t) {
    t19 = t("guide.KYC_ADVANTAGES");
    $[41] = t;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19) {
    t20 = <h2 className="text-center text-lg md:text-2xl font-bold text-charcoal-900">{t19}</h2>;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t) {
    t21 = Data.kycBenefits.map((item_0, index_0) => <div key={index_0} className="sm:h-full py-2 md:py-7 sm:py-0"><div className="flex items-center gap-x-5">{renderGuideIcon(item_0.icon)}<h3 className="my-5 font-semibold text-charcoal-900">{t(item_0.title)}</h3></div><p className="text-charcoal-600 font-normal">{t(item_0.text)}</p></div>);
    $[45] = t;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21) {
    t22 = <div className="flex justify-center w-full"><div className="sm:grid grid-cols-2 gap-x-16 items-center pt-3 mt-5 w-full">{t21}</div></div>;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t20 || $[50] !== t22) {
    t23 = <div className="my-10 md:my-32 flex flex-col items-center"><div className="">{t20}{t22}</div></div>;
    $[49] = t20;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== t13 || $[53] !== t18 || $[54] !== t23) {
    t24 = <div className="container px-8 md:px-20 mx-auto">{t13}{t18}{t23}</div>;
    $[52] = t13;
    $[53] = t18;
    $[54] = t23;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== t) {
    t25 = t("guide.KYC_STEPS");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t25) {
    t26 = <h3 className="font-bold text-xl text-charcoal-900">{t25}</h3>;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t) {
    t27 = Data.kycSteps.map((item_1, index_1) => <div key={item_1.id} className="flex justify-start gap-x-6"><div className="flex flex-col items-center self-stretch"><div className="bg-accent-02 w-5 h-5 rounded-full flex justify-center items-center p-4">{item_1.id}</div><div className={`w-0.5 flex-1 ${index_1 == Data.kycSteps.length - 1 ? "hidden" : "bg-accent-02"}`} /></div><div className="min-h-fit py-3"><h4 className="text-base font-semibold text-charcoal-900">{t(item_1.title)}</h4><p className="text-sm font-normal text-charcoal-600 pt-3">{t(item_1.text)}</p></div></div>);
    $[60] = t;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  let t28;
  if ($[62] !== t27) {
    t28 = <div className=" h-full mt-10">{t27}</div>;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== t) {
    t29 = t("guide.KYC_STEPS_TEXT");
    $[64] = t;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t29) {
    t30 = <p className="font-semibold text-charcoal-900">{t29}</p>;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== router || $[69] !== token) {
    t31 = () => router.push(token ? "/dashboard/KYC/1" : "/auth");
    $[68] = router;
    $[69] = token;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t) {
    t32 = t("guide.AUTHENTICATION");
    $[71] = t;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t31 || $[74] !== t32) {
    t33 = <div className="mt-7 mb-7 md:mb-0"><Button variant="solid" color="primary" size="md" onClick={t31}>{t32}</Button></div>;
    $[73] = t31;
    $[74] = t32;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== t30 || $[77] !== t33) {
    t34 = <div className="mt-6">{t30}{t33}</div>;
    $[76] = t30;
    $[77] = t33;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  let t35;
  if ($[79] !== t26 || $[80] !== t28 || $[81] !== t34) {
    t35 = <div>{t26}{t28}{t34}</div>;
    $[79] = t26;
    $[80] = t28;
    $[81] = t34;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <div className="flex justify-end w-full"><img alt="bitmax" src="/images/guide/photo.png" className="w-full" /></div>;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t35) {
    t37 = <div className="container px-8 md:px-20 mx-auto"><div className="md:grid grid-cols-2 gap-x-10 items-center">{t35}{t36}</div></div>;
    $[84] = t35;
    $[85] = t37;
  } else {
    t37 = $[85];
  }
  let t38;
  if ($[86] !== t) {
    t38 = Data.startPoint.map((item_2, index_2) => <div key={index_2} className="sm:grid grid-cols-12 gap-x-6 items-center"><div className="col-span-4"><h3 className="font-bold text-charcoal-900 sm:hidden pb-4">{t(item_2.title)}</h3><img src={item_2.img} alt={t(item_2.title)} className="w-full" /></div><div className="col-span-8 pt-6 sm:pt-0"><h3 className="font-bold text-charcoal-900 hidden sm:block">{t(item_2.title)}</h3><p className="font-normal text-sm text-charcoal-600 sm:mt-2 text-justify">{t(item_2.text)} <span className="text-bluetiful-400"><Link target="_blank" href={item_2.link}>{t("guide.READ_MORE")}</Link></span></p></div></div>);
    $[86] = t;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== t38) {
    t39 = <div className="container md:pb-10 pb-0 px-8 md:px-20 mx-auto"><div className="space-y-14 my-24">{t38}</div></div>;
    $[88] = t38;
    $[89] = t39;
  } else {
    t39 = $[89];
  }
  let t40;
  if ($[90] !== t) {
    t40 = t("guide.BTC");
    $[90] = t;
    $[91] = t40;
  } else {
    t40 = $[91];
  }
  let t41;
  if ($[92] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <br />;
    $[92] = t41;
  } else {
    t41 = $[92];
  }
  let t42;
  if ($[93] !== t) {
    t42 = t("guide.CRYPTO_KING");
    $[93] = t;
    $[94] = t42;
  } else {
    t42 = $[94];
  }
  let t43;
  if ($[95] !== t40 || $[96] !== t42) {
    t43 = <h2 className="text-2xl lg:text-3xl font-bold text-charcoal-900 !leading-relaxed text-center lg:text-start pb-6 lg:pb-0">{t40}{t41}{t42}</h2>;
    $[95] = t40;
    $[96] = t42;
    $[97] = t43;
  } else {
    t43 = $[97];
  }
  let t44;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <div className="lg:hidden flex justify-center w-full"><img className="" alt="BitCoin" src="/images/guide/BTC.png" /></div>;
    $[98] = t44;
  } else {
    t44 = $[98];
  }
  let t45;
  if ($[99] !== t) {
    t45 = t("guide.BTC_TEXT");
    $[99] = t;
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  let t46;
  if ($[101] !== t45) {
    t46 = <p className="lg:text-lg 2xl:text-xl leading-9 font-semibold text-charcoal-600 mt-2 text-justify">{t45}</p>;
    $[101] = t45;
    $[102] = t46;
  } else {
    t46 = $[102];
  }
  let t47;
  if ($[103] !== t43 || $[104] !== t46) {
    t47 = <div className="lg:max-w-md 2xl:max-w-xl">{t43}{t44}{t46}</div>;
    $[103] = t43;
    $[104] = t46;
    $[105] = t47;
  } else {
    t47 = $[105];
  }
  let t48;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <div className="hidden lg:flex justify-end"><img className="w-112 2xl:w-full" alt="BitCoin" src="/images/guide/BTC.png" /></div>;
    $[106] = t48;
  } else {
    t48 = $[106];
  }
  let t49;
  if ($[107] !== t47) {
    t49 = <div className="flex items-center"><div className="container px-8 md:px-20 mx-auto "><div className="lg:grid grid-cols-2 gap-x-10 items-center">{t47}{t48}</div></div></div>;
    $[107] = t47;
    $[108] = t49;
  } else {
    t49 = $[108];
  }
  let t50;
  if ($[109] !== t) {
    t50 = Data.coins.map((item_3, index_3) => <div key={index_3} className="sm:grid grid-cols-12 gap-x-4 md:gap-x-24 items-center"><div className="col-span-3 sm:col-span-3"><img src={item_3.img} alt={t(item_3.name)} className="w-full" /></div><div className="col-span-9 sm:col-span-9 pt-6 sm:pt-0"><h3 className="font-bold text-charcoal-900">{t(item_3.name)}</h3><p className="text-sm font-normal text-charcoal-600 mt-2 md::mt-10 text-justify">{t(item_3.text)}<span className="text-bluetiful-400">{t("guide.READ_MORE")}</span></p></div></div>);
    $[109] = t;
    $[110] = t50;
  } else {
    t50 = $[110];
  }
  let t51;
  if ($[111] !== t50) {
    t51 = <div className="container py-5 px-8 md:px-20 mx-auto"><div className="space-y-14 my-16">{t50}</div></div>;
    $[111] = t50;
    $[112] = t51;
  } else {
    t51 = $[112];
  }
  let t52;
  if ($[113] !== t) {
    t52 = t("guide.HOW_TO_USE_PLATFORM");
    $[113] = t;
    $[114] = t52;
  } else {
    t52 = $[114];
  }
  let t53;
  if ($[115] !== t52) {
    t53 = <div className=" mb-20"><h3 className="text-center text-xl md:text-3xl font-semibold">{t52}</h3></div>;
    $[115] = t52;
    $[116] = t53;
  } else {
    t53 = $[116];
  }
  let t54;
  if ($[117] !== t) {
    t54 = t("general.COMPANY_NAME");
    $[117] = t;
    $[118] = t54;
  } else {
    t54 = $[118];
  }
  let t55;
  if ($[119] !== t54) {
    t55 = <div className="flex justify-center w-full"><img src="/images/guide/screen.png" alt={t54} className="max-w-3xl w-full" /></div>;
    $[119] = t54;
    $[120] = t55;
  } else {
    t55 = $[120];
  }
  let t56;
  if ($[121] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <GuideBuyIcon className={whiteGuideActionIconClassName} />;
    $[121] = t56;
  } else {
    t56 = $[121];
  }
  let t57;
  if ($[122] !== t) {
    t57 = t("general.BUY");
    $[122] = t;
    $[123] = t57;
  } else {
    t57 = $[123];
  }
  let t58;
  if ($[124] !== t57) {
    t58 = <div className="flex items-center gap-x-4">{t56}<p className="text-base md:text-xl font-semibold text-charcoal-900">{t57}</p></div>;
    $[124] = t57;
    $[125] = t58;
  } else {
    t58 = $[125];
  }
  let t59;
  if ($[126] !== router) {
    t59 = () => router.push("/comparison");
    $[126] = router;
    $[127] = t59;
  } else {
    t59 = $[127];
  }
  let t60;
  if ($[128] !== t) {
    t60 = t("guide.CLICK");
    $[128] = t;
    $[129] = t60;
  } else {
    t60 = $[129];
  }
  let t61;
  if ($[130] !== t59 || $[131] !== t60) {
    t61 = <Button variant="solid" color="primary" size="md" onClick={t59}>{t60}</Button>;
    $[130] = t59;
    $[131] = t60;
    $[132] = t61;
  } else {
    t61 = $[132];
  }
  let t62;
  if ($[133] !== t58 || $[134] !== t61) {
    t62 = <div className="flex justify-between items-center w-full">{t58}{t61}</div>;
    $[133] = t58;
    $[134] = t61;
    $[135] = t62;
  } else {
    t62 = $[135];
  }
  let t63;
  if ($[136] !== t) {
    t63 = t("guide.BUY_TEXT");
    $[136] = t;
    $[137] = t63;
  } else {
    t63 = $[137];
  }
  let t64;
  if ($[138] !== t63) {
    t64 = <div className="mt-5"><p className="text-charcoal-600 font-light text-justify">{t63}</p></div>;
    $[138] = t63;
    $[139] = t64;
  } else {
    t64 = $[139];
  }
  let t65;
  if ($[140] !== t62 || $[141] !== t64) {
    t65 = <div>{t62}{t64}</div>;
    $[140] = t62;
    $[141] = t64;
    $[142] = t65;
  } else {
    t65 = $[142];
  }
  let t66;
  if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <GuideSellIcon className={whiteGuideActionIconClassName} />;
    $[143] = t66;
  } else {
    t66 = $[143];
  }
  let t67;
  if ($[144] !== t) {
    t67 = t("general.SELL");
    $[144] = t;
    $[145] = t67;
  } else {
    t67 = $[145];
  }
  let t68;
  if ($[146] !== t67) {
    t68 = <div className="flex items-center gap-x-4">{t66}<p className="text-base md:text-xl font-semibold text-charcoal-900">{t67}</p></div>;
    $[146] = t67;
    $[147] = t68;
  } else {
    t68 = $[147];
  }
  let t69;
  if ($[148] !== router) {
    t69 = () => router.push("/comparison/?side=sell");
    $[148] = router;
    $[149] = t69;
  } else {
    t69 = $[149];
  }
  let t70;
  if ($[150] !== t) {
    t70 = t("guide.CLICK");
    $[150] = t;
    $[151] = t70;
  } else {
    t70 = $[151];
  }
  let t71;
  if ($[152] !== t69 || $[153] !== t70) {
    t71 = <Button variant="solid" color="primary" size="md" onClick={t69}>{t70}</Button>;
    $[152] = t69;
    $[153] = t70;
    $[154] = t71;
  } else {
    t71 = $[154];
  }
  let t72;
  if ($[155] !== t68 || $[156] !== t71) {
    t72 = <div className="flex justify-between items-center w-full">{t68}{t71}</div>;
    $[155] = t68;
    $[156] = t71;
    $[157] = t72;
  } else {
    t72 = $[157];
  }
  let t73;
  if ($[158] !== t) {
    t73 = t("guide.SELL_TEXT");
    $[158] = t;
    $[159] = t73;
  } else {
    t73 = $[159];
  }
  let t74;
  if ($[160] !== t73) {
    t74 = <div className="mt-5"><p className="text-charcoal-600 font-light text-justify">{t73}</p></div>;
    $[160] = t73;
    $[161] = t74;
  } else {
    t74 = $[161];
  }
  let t75;
  if ($[162] !== t72 || $[163] !== t74) {
    t75 = <div className="pt-9 md:pt-0">{t72}{t74}</div>;
    $[162] = t72;
    $[163] = t74;
    $[164] = t75;
  } else {
    t75 = $[164];
  }
  let t76;
  if ($[165] !== t65 || $[166] !== t75) {
    t76 = <div className="md:grid grid-cols-2 gap-x-10 mt-16">{t65}{t75}</div>;
    $[165] = t65;
    $[166] = t75;
    $[167] = t76;
  } else {
    t76 = $[167];
  }
  let t77;
  if ($[168] !== t53 || $[169] !== t55 || $[170] !== t76) {
    t77 = <div className="bg-right-to-left-gradient py-7 md:py-16"><div className="container px-8 md:px-20 md:mx-auto">{t53}{t55}{t76}</div></div>;
    $[168] = t53;
    $[169] = t55;
    $[170] = t76;
    $[171] = t77;
  } else {
    t77 = $[171];
  }
  let t78;
  if ($[172] !== t) {
    t78 = t("guide.ABOUT_US");
    $[172] = t;
    $[173] = t78;
  } else {
    t78 = $[173];
  }
  let t79;
  if ($[174] !== t78) {
    t79 = <h2 className="text-charcoal-900 font-bold"> {t78}</h2>;
    $[174] = t78;
    $[175] = t79;
  } else {
    t79 = $[175];
  }
  let t80;
  if ($[176] !== t) {
    t80 = t("guide.ABOUT_US_TEXT");
    $[176] = t;
    $[177] = t80;
  } else {
    t80 = $[177];
  }
  let t81;
  if ($[178] !== t80) {
    t81 = <p className="text-sm font-semibold text-charcoal-900 mt-5 text-justify">{t80}</p>;
    $[178] = t80;
    $[179] = t81;
  } else {
    t81 = $[179];
  }
  let t82;
  if ($[180] !== t79 || $[181] !== t81) {
    t82 = <div className="container pt-16 pb-10 px-8 md:px-20 mx-auto">{t79}{t81}</div>;
    $[180] = t79;
    $[181] = t81;
    $[182] = t82;
  } else {
    t82 = $[182];
  }
  let t83;
  if ($[183] !== t24 || $[184] !== t37 || $[185] !== t39 || $[186] !== t49 || $[187] !== t51 || $[188] !== t77 || $[189] !== t8 || $[190] !== t82) {
    t83 = <>{t8}{t24}{t37}{t39}{t49}{t51}{t77}{t82}</>;
    $[183] = t24;
    $[184] = t37;
    $[185] = t39;
    $[186] = t49;
    $[187] = t51;
    $[188] = t77;
    $[189] = t8;
    $[190] = t82;
    $[191] = t83;
  } else {
    t83 = $[191];
  }
  return t83;
}